/**
 * Deterministic human-like anonymization names.
 * Same entity ID always maps to the same name. No real companies or institutions.
 */

/** Realistic fake partner/distributor names */
export const DISTRIBUTOR_NAMES = [
  'Summit Beverage Co',
  'Riverside Distribution',
  'Pioneer Coffee Supply',
  'Horizon Beverage Services',
  'Pine Grove Distributors',
  'Cedar Creek Partners',
  'Stonebridge Beverage Co',
  'Maple Valley Supply',
  'Brookside Distribution',
  'Highland Coffee Partners',
  'Ridgeview Beverage',
  'Lakeside Distribution Co',
  'Valley View Partners',
  'Northgate Supply Co',
  'Westfield Beverage',
  'Eastbrook Distribution',
  'Clearwater Partners',
  'Silver Creek Supply',
  'Oakwood Beverage Co',
  'Greenfield Distribution',
];

/** Realistic fake client/institution names */
export const CLIENT_NAMES = [
  'Pacific University',
  'Northern Tech',
  'Greenfield Medical Center',
  'Riverside Hospital',
  'Summit Corporate Campus',
  'Valley View College',
  'Lakeside Medical Group',
  'Pine Grove Academy',
  'Stonebridge Healthcare',
  'Highland Business Park',
  'Brookside Community Center',
  'Cedar Creek University',
  'Maple Valley Hospital',
  'Horizon Research Institute',
  'Ridgeview Corporate Center',
  'Westfield Medical Plaza',
  'Northgate Community College',
  'Clearwater Health System',
  'Silver Creek University',
  'Oakwood Corporate Campus',
];

/** Realistic fake campus/building names */
export const CAMPUS_NAMES = [
  'Downtown Campus',
  'North Building',
  'West Side Complex',
  'Main Building',
  'East Wing',
  'Central Plaza',
  'Riverside Hall',
  'Summit Tower',
  'Valley View Center',
  'Lakeside Annex',
  'Pine Grove Building',
  'Stonebridge Hall',
  'Highland Complex',
  'Brookside Center',
  'Cedar Creek Building',
  'Maple Valley Hall',
  'Horizon Tower',
  'Ridgeview Center',
  'Westfield Annex',
  'Northgate Building',
];

/** Realistic fake market/region names */
export const MARKET_NAMES = [
  'Pacific Northwest',
  'Central Valley',
  'Midwest Region',
  'Southeast District',
  'Northern Plains',
  'Coastal Division',
  'Mountain West',
  'Great Lakes Area',
  'Southwest Region',
  'Atlantic Northeast',
  'Central Plains',
  'Gulf Coast District',
  'Upper Midwest',
  'Pacific Coast',
  'Eastern Seaboard',
  'Rocky Mountain Region',
  'Southern Tier',
  'North Central',
  'Western Slope',
  'Delta Region',
];

/** Machine location names - where the machine is typically placed in a campus */
export const MACHINE_LOCATION_NAMES = [
  'Main Lobby',
  'Break Room A',
  'Floor 2 South',
  'Cafeteria',
  'Conference Room B',
  'Reception',
  'Floor 2 North',
  'Atrium',
  'Kitchen',
  'Admin Suite',
  'Break Room B',
  'Floor 3 East',
  'Lounge',
  'Training Room',
  'Floor 1 West',
  'Café Area',
  'Executive Suite',
  'Floor 3 West',
  'Common Area',
  'Wellness Center',
  'Floor 4 North',
  'Patio',
  'Visitor Center',
  'Floor 4 South',
  'Copy Room',
  'Floor 1 East',
  'Meeting Room A',
  'Floor 5',
  'Cafeteria Annex',
  'Break Room C',
];
